import { gql } from '@apollo/client';

export const BOOK_APPOINTMENT = gql`
  mutation BookAppointment($data: BookAppointmentInput!) {
    bookAppointment(data: $data) {
      ... on BookAppointmentPayload {
        id
        serviceName
        activityType
        startTime
        branch {
          name
        }
      }
      ... on Error {
        error
      }
    }
  }
`;
